module.exports = __webpack_public_path__ + "img/m_Citadel.ef38a8a3.png";